<template>
  <div class="info-new-line" :class="{ 'error': validate, 'shrink': value || state.shrink }">
    <label class="label-class" :class="{ 'necessary-class': necessary}">{{ label }}</label>
    <Input v-if="!textarea" :value="value" v-bind="$attrs" :disabled="disabled" @blur="onBlur" @input="onInput" @focus="onFocus" :maxlength="maxlength" >
      <template #suffix>
        <a-tooltip :title="title" v-if="title" color="rgba(0,0,0,.7)" overlayClassName="tooltip-tips">
          <!-- 伪元素展示隐藏箭头 -->
          <div class="tooltip-icon">
            <img style="width: 16px" src="@/assets/icon/tip.svg" alt="">
          </div>
        </a-tooltip>
      </template>
    </Input>
    <template v-else>
      <Textarea :value="value" show-count v-bind="$attrs" :disabled="disabled" @blur="onBlur" @input="onInput" @focus="onFocus" :maxlength="maxlength" :rows="rows" />
      <a-tooltip :title="title" v-if="title" color="rgba(0,0,0,.7)" overlayClassName="tooltip-tips">
        <div class="tooltip-icon tip-textarea">
          <img style="width: 16px" src="@/assets/icon/tip.svg" alt="">
        </div>
      </a-tooltip>
    </template>
    <span class="error-class" v-if="validate">{{ rulesContent }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { Input, Tooltip } from 'ant-design-vue'

export default defineComponent({
  components: {
    Input,
    Textarea: Input.TextArea,
    'a-tooltip': Tooltip
  },
  props: [
    'value', 'label', 'disabled', 'rulesContent', 'necessary', 'maxlength',
    'textarea', 'rows', 'validate', 'title', 'disableUpdate'
  ],
  emits: ['update:value', 'update:validate', 'blur', 'input', 'focus'],
  setup (props, ctx) {
    const state = reactive({
      shrink: false
    })
    const { value, disableUpdate } = toRefs(props)
    return {
      value,
      state,
      onBlur (val: any) {
        if (!disableUpdate.value) {
          ctx.emit('update:value', val.target.value)
        }
        ctx.emit('blur', val.target.value)
        state.shrink = false
      },
      onInput (val: any) {
        if (!disableUpdate.value) {
          ctx.emit('update:value', val.target.value)
        }
        ctx.emit('input', val.target.value)
        if (!val.target.value && props.necessary) {
          ctx.emit('update:validate', true)
        } else {
          ctx.emit('update:validate', false)
        }
      },
      onFocus (val: any) {
        if (!disableUpdate.value) {
          ctx.emit('update:value', val.target.value)
        }
        ctx.emit('focus', val.target.value)
        state.shrink = true
      }
    }
  }
})
</script>

<style lang="less" scoped>
.info-new-line {
  display: flex;
  position: relative;
  margin-bottom: 24px;
  .ant-input {
    height: 40px;
  }
  .label-class {
    align-items: center;
    background-color: transparent;
    color: #999;
    font-size: 14px;
    font-weight: 400;
    left: 0;
    line-height: 18px;
    margin: 0 8px;
    max-width: calc(100% - 16px);
    overflow: hidden;
    padding: 0 12px 0 4px;
    pointer-events: none;
    position: absolute;
    top: 11px;
    transform-origin: left top;
    transition: .3s ease-out;
    white-space: nowrap;
    z-index: 1;

    &::before {
      content: "";
      height: 0;
      left: 0;
      position: absolute;
      top: 9px;
      width: 100%;
      z-index: -1;
    }
  }
  .tip-textarea {
    width: 16px;
    position: absolute;
    right: 11px;
    bottom: 7px;
  }
  .ant-input-affix-wrapper {
    height: 40px;
  }
  .error-class {
    color: @theme-color;
    position: absolute;
    font-size: 12px;
    left: 0;
    bottom: -20px;
  }
  .necessary-class {
    &::after {
      position: absolute;
      content: "*";
      color: @theme-color;
      padding-left: 2px;
    }
  }
  .ant-input-textarea-show-count::after {
    position: absolute;
    bottom: 4px;
    right: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
.shrink {
  .label-class {
    top: 3px !important;
    transform: translateY(-50%) scale(.75) !important;
    background: linear-gradient(to bottom, #fff 60%, transparent 40%);
  }
}
.error {
  .label-class {
    color: @theme-color;
  }
  :deep(.ant-input) {
    border-color: @theme-color !important;
  }
}
.tooltip-icon {
  position: relative;
  &::before {
    visibility: hidden;
    transition-delay: 0.1s;
    content: '';
    position: absolute;
    top: -12px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    transform: rotate(180deg);
    border-style: solid;
    border-color: transparent transparent #333 transparent;
  }
  &:hover::before {
    visibility: visible;
    transition: visibility 0s linear 0.1s;
  }
}
@media only screen and (max-width: 992px) {
  .info-new-line {
    margin-bottom: 2.4rem;

    .label-class {
      font-size: 1.4rem;
      top: 1.1rem;
      line-height: 1.8rem;
    }
    .error-class {
      font-size: 1.2rem;
      bottom: -2rem;
    }
    .tooltip-icon::before {
      top: -1.2rem;
    }
  }
}
.rtl--container {
  .info-new-line {
    .label-class {
      left: auto;
      padding: 0 4px 0 12px;
      transform-origin: right top;
    }
    .tip-textarea {
      right: auto;
      left: 11px;
    }
    .ant-input-textarea-show-count::after {
      left: 12px;
      right: auto;
    }
    .ant-input-affix-wrapper {
      :deep(.ant-input-suffix) {
        margin: 0 4px 0 0;
      }
    }
  }
}
</style>
